import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { TITLE_INHERIT_STYLE, TITLE_PRIMARY_STYLE } from "@constants";
import "./css/MyBillingAddress.scss";
import "./css/MyDetails.scss";
import { MyBillingAddress } from "./MyBillingAddress";
import { MyDetails } from "./MyDetails";

export const UserDetailsPage = () => {
    const { t } = useTranslation("profile");

    return (
        <Fragment>
            <Card className="mydetail" elevation={2}>
                <CardHeader title={t("myDetails")} titleTypographyProps={TITLE_PRIMARY_STYLE} />
                <MyDetails />
            </Card>
            <Card className="profileBilling" elevation={2}>
                <CardHeader
                    className="card-header card-header__right"
                    title={t("myBillingAddress")}
                    titleTypographyProps={TITLE_INHERIT_STYLE}
                />
                <CardContent>
                    <div className="card-header__circle" />
                    <MyBillingAddress />
                </CardContent>
            </Card>
        </Fragment>
    );
};
